import React, { useState, useRef, useEffect, useCallback } from "react";
import { createPortal } from "react-dom";

export default function TooltipIcon({ content }) {
  const [show, setShow] = useState(false);
  const btnRef = useRef(null);
  const popupRef = useRef(null);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  const updatePosition = useCallback(() => {
    if (btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      const popupWidth = 384; // 24rem
      let left = rect.right + 8;
      // If popup would go off-screen right, show it on the left side
      if (left + popupWidth > window.innerWidth) {
        left = Math.max(8, rect.left - popupWidth - 8);
      }
      let top = rect.top;
      // If popup would go off-screen bottom, shift it up
      if (top + 300 > window.innerHeight) {
        top = Math.max(8, window.innerHeight - 400);
      }
      setPos({ top, left });
    }
  }, []);

  useEffect(() => {
    if (show) {
      updatePosition();
    }
  }, [show, updatePosition]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        btnRef.current && !btnRef.current.contains(e.target) &&
        popupRef.current && !popupRef.current.contains(e.target)
      ) {
        setShow(false);
      }
    }
    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [show]);

  return (
    <>
      <button
        type="button"
        ref={btnRef}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShow(!show);
        }}
        className="inline-flex items-center justify-center w-5 h-5 rounded-full border border-blue-500 text-blue-500 text-xs font-bold hover:bg-blue-50 cursor-pointer ml-1"
        style={{ lineHeight: 1 }}
      >
        ?
      </button>
      {show &&
        createPortal(
          <div
            ref={popupRef}
            style={{
              position: "fixed",
              top: pos.top,
              left: pos.left,
              zIndex: 99999,
              width: "24rem",
              maxWidth: "calc(100vw - 16px)",
              maxHeight: "24rem",
              overflowY: "auto",
              backgroundColor: "white",
              border: "1px solid #d1d5db",
              borderRadius: "0.5rem",
              boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
              padding: "1rem",
              fontSize: "0.875rem",
              color: "#374151",
              whiteSpace: "pre-line",
            }}
          >
            {content}
            <button
              type="button"
              onClick={() => setShow(false)}
              style={{
                position: "absolute",
                top: "0.5rem",
                right: "0.5rem",
                background: "none",
                border: "none",
                fontSize: "1.25rem",
                cursor: "pointer",
                color: "#9ca3af",
              }}
            >
              &times;
            </button>
          </div>,
          document.body
        )}
    </>
  );
}
